import { lazy } from 'react'
import {
  ROLE_CRUD_USER,
  ROLE_BRAND_MANAGEMENT,
  ROLE_PRODUCT_LIST,
  ROLE_COMPLAINT_LIST,
  ROLE_MARCA_PRE_CAD_CONSULTORIA,
  ROLE_MARCA_PRE_CAD_ADMIN,
  ROLE_MARCA_PRE_CAD_VINCULO,
  ROLE_CONSULTANT_BRAND_ACTIONS,
  ROLE_REASON_COMPLAINT_MANAGEMENT,
  ROLE_REASON_COMPLAINT_NEW,
  ROLE_ADS_ALLOWED_REPORT,
  ROLE_ADS_REMOVED_REPORT,
  ROLE_ADS_TO_REMOVE_REPORT,
  ROLE_ACTIVE_BRAND_REPORT,
  ROLE_REGULATORY_AGENCY_MANAGEMENT,
  ROLE_REGULATORY_AGENCY_NEW,
  ROLE_SUB_SPECIFICATION_NEW,
  ROLE_SUB_SPECIFICATION_MANAGEMENT,
  ROLE_TICKETS_MANAGEMENT,
} from 'common/constants/roles'
import { ERoute } from 'common/entities/routes'

const Home = lazy(() => import('pages/Home'))
const Users = lazy(() => import('pages/Users'))
const BrandManagement = lazy(() => import('pages/BrandManagement'))
const RegisterNewBrand = lazy(() => import('pages/Brands/RegisterNewBrand'))
const LinkUserToBrand = lazy(() => import('pages/LinkUserToBrand'))
const RegisterBrandConsultant = lazy(() => import('pages/RegisterBrandConsultant'))
const ComplaintsManagement = lazy(() => import('pages/ComplaintsManagement'))
const Catalog = lazy(() => import('pages/Catalog'))
const ReasonComplaintManagement = lazy(() => import('pages/ReasonComplaintManagement'))
const RegisterNewReasonComplaint = lazy(
  () => import('pages/ReasonComplaint/RegisterNewReasonComplaint')
)
const Reports = lazy(() => import('pages/Reports'))
const Faq = lazy(() => import('pages/FAQ'))
const AcceptanceTerm = lazy(() => import('containers/AcceptanceTerm'))
const RegulatoryAgencyManagement = lazy(() => import('pages/RegulatoryAgencyManagement'))
const RegisterNewRegulatoryAgency = lazy(
  () => import('pages/RegulatoryAgency/RegisterNewRegulatoryAgency')
)
const AllTicketsManagement = lazy(() => import('pages/AllTicketsManagement'))
const ServiceReportsManagement = lazy(() => import('pages/ServiceReportsManagement'))
const ImportTickets = lazy(() => import('pages/ImportTicket'))
const SubSpecificationManagement = lazy(() => import('pages/SubSpecificationManagement'))
const RegisterNewSubSpecification = lazy(
  () => import('pages/SubSpecification/RegisterNewSubSpecification')
)

const app = [
  {
    path: ERoute.HOME,
    component: Home,
    exact: true,
  },
  {
    path: ERoute.USERS,
    component: Users,
    exact: true,
    roles: [ROLE_CRUD_USER],
  },
  {
    path: ERoute.BRAND_MANAGEMENT,
    component: BrandManagement,
    exact: true,
    roles: [ROLE_BRAND_MANAGEMENT],
  },
  {
    path: ERoute.REGISTER_NEW_BRAND,
    component: RegisterNewBrand,
    exact: true,
    roles: [ROLE_MARCA_PRE_CAD_ADMIN],
  },
  {
    path: ERoute.LINK_USER_TO_BRAND,
    component: LinkUserToBrand,
    exact: true,
    roles: [ROLE_MARCA_PRE_CAD_VINCULO],
  },
  {
    path: ERoute.EDIT_BRAND,
    component: RegisterNewBrand,
    exact: true,
    roles: [ROLE_BRAND_MANAGEMENT],
  },
  {
    path: ERoute.REGISTER_NEW_PARTNER_BRAND,
    component: RegisterNewBrand,
    exact: true,
    roles: [ROLE_BRAND_MANAGEMENT],
  },
  {
    path: ERoute.REGISTER_NEW_BRAND_CONSULTANT,
    component: RegisterBrandConsultant,
    exact: true,
    roles: [ROLE_MARCA_PRE_CAD_CONSULTORIA, ROLE_CONSULTANT_BRAND_ACTIONS],
  },
  {
    path: ERoute.REGISTER_BRAND_CONSULTANT,
    component: RegisterBrandConsultant,
    exact: true,
    roles: [ROLE_MARCA_PRE_CAD_CONSULTORIA, ROLE_CONSULTANT_BRAND_ACTIONS],
  },
  {
    path: ERoute.COMPLAINTS_MANAGEMENT,
    component: ComplaintsManagement,
    exact: true,
    roles: [ROLE_COMPLAINT_LIST],
  },
  {
    path: ERoute.CATALOG,
    component: Catalog,
    exact: true,
    roles: [ROLE_PRODUCT_LIST],
  },
  {
    path: ERoute.REASON_COMPLAINT_MANAGEMENT,
    component: ReasonComplaintManagement,
    exact: true,
    roles: [ROLE_REASON_COMPLAINT_MANAGEMENT],
  },
  {
    path: ERoute.REGISTER_NEW_REASON_COMPLAINT,
    component: RegisterNewReasonComplaint,
    exact: true,
    roles: [ROLE_REASON_COMPLAINT_NEW],
  },
  {
    path: ERoute.EDIT_REASON_COMPLAINT,
    component: RegisterNewReasonComplaint,
    exact: true,
    roles: [ROLE_REASON_COMPLAINT_NEW],
  },
  {
    path: ERoute.REPORTS,
    component: Reports,
    exact: true,
    roles: [
      ROLE_ADS_ALLOWED_REPORT,
      ROLE_ADS_REMOVED_REPORT,
      ROLE_ADS_TO_REMOVE_REPORT,
      ROLE_ACTIVE_BRAND_REPORT,
    ],
  },
  {
    path: ERoute.FAQ,
    component: Faq,
    exact: true,
  },
  {
    path: ERoute.ACCEPTANCE_TERM,
    component: AcceptanceTerm,
    exact: true,
  },
  {
    path: ERoute.REGULATORY_AGENCY_MANAGEMENT,
    component: RegulatoryAgencyManagement,
    exact: true,
    roles: [ROLE_REGULATORY_AGENCY_MANAGEMENT],
  },
  {
    path: ERoute.REGISTER_NEW_REGULATORY_AGENCY,
    component: RegisterNewRegulatoryAgency,
    exact: true,
    roles: [ROLE_REGULATORY_AGENCY_NEW],
  },
  {
    path: ERoute.EDIT_REGULATORY_AGENCY,
    component: RegisterNewRegulatoryAgency,
    exact: true,
    roles: [ROLE_REGULATORY_AGENCY_NEW],
  },
  {
    path: ERoute.ALL_TICKETS_MANAGEMENT,
    component: AllTicketsManagement,
    exact: true,
    roles: [ROLE_TICKETS_MANAGEMENT],
  },
  {
    path: ERoute.SERVICE_REPORTS_MANAGEMENT,
    component: ServiceReportsManagement,
    exact: true,
    roles: [ROLE_TICKETS_MANAGEMENT],
  },
  {
    path: ERoute.IMPORT_TICKETS,
    component: ImportTickets,
    exact: true,
    roles: [ROLE_TICKETS_MANAGEMENT],
  },
  {
    path: ERoute.SUB_SPECIFICATION_MANAGEMENT,
    component: SubSpecificationManagement,
    exact: true,
    roles: [ROLE_SUB_SPECIFICATION_MANAGEMENT],
  },
  {
    path: ERoute.REGISTER_NEW_SUB_SPECIFICATION,
    component: RegisterNewSubSpecification,
    exact: true,
    roles: [ROLE_SUB_SPECIFICATION_NEW],
  },
  {
    path: ERoute.EDIT_SUB_SPECIFICATION,
    component: RegisterNewSubSpecification,
    exact: true,
    roles: [ROLE_SUB_SPECIFICATION_NEW],
  },
]

export default app
